var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointerMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.67508C0 3.44262 3.58939 0 8 0C12.4116 0 16 3.44262 16 7.67508C16 9.39246 15.3879 11.0813 14.2769 12.4289L8 20L1.72583 12.4325C0.612072 11.0813 0 9.39246 0 7.67508ZM5 8C5 9.65368 6.34632 11 8 11C9.65471 11 11 9.65368 11 8C11 6.34563 9.65471 5 8 5C6.34632 5 5 6.34529 5 8Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointerMap);
export default __webpack_public_path__ + "static/media/pointer-map.67549fc2057bf822075a20cadf85024a.svg";
export { ForwardRef as ReactComponent };